import { ReactionsService } from '@/service/ReactionsService'
import Model from './Model'

export enum ContentType {
  POST = 'POST',
  COMMENT = 'COMMENT',
}

export enum ReactionType {
  LIKE = 'LIKE',
  HEART = 'HEART',
  SMILEY = 'SMILEY',
}

export interface IReaction {
  _id?: string
  contentId: string
  contentType: ContentType
  reactionType: ReactionType
  createdBy: string
  channelSlug?: string
  parentContentId?: string
}

export interface IGetReactions {
  _id?: string
  reactionType: ReactionType
  reactedUser?: {
    fullName: string
    slug: string
    avatar?: string
    title?: string
    contactId?: string
  }
}

export default class Reactions extends Model {
  constructor(payload: IReaction) {
    super(payload, ReactionsService)
  }

  get contentId(): string {
    return this._data.contentId
  }

  set contentId(contentId: string) {
    this._data.contentId = contentId
  }

  get contentType(): string {
    return this._data.contentType
  }

  set contentType(contentType: string) {
    this._data.contentType = contentType
  }

  get reactionType(): string {
    return this._data.reactionType
  }

  set reactionType(reactionType: string) {
    this._data.reactionType = reactionType
  }

  get createdBy(): string {
    return this._data.createdBy
  }

  set createdBy(createdBy: string) {
    this._data.createdBy = createdBy
  }
}
